import React from 'react';
import { Button, Modal, ModalHeader } from 'semantic-ui-react';
import { useTranslation } from "react-i18next";

const ChangeBookingTypeModal = ({ isOpen, onRequestClose, submit }) => {

    const { t } = useTranslation();

    return (
        <>
            <Modal
                open={isOpen}
                size="tiny"
            >
                <ModalHeader><p>{t('booking_continue')}</p></ModalHeader>
                <Modal.Content>
                    {t('booking_type_changed')}
                </Modal.Content>
                <Modal.Actions className='flex justify-center'>
                    <Button
                        form="booking-form"
                        type="submit"
                        primary
                        onClick={() => {
                            submit();
                            onRequestClose();
                        }}
                    >
                        {t("Actualizar Booking")}
                    </Button>
                    <Button onClick={onRequestClose}>
                        {t("canceled_button")}
                    </Button>
                </Modal.Actions>
            </Modal>
        </>
    );
};

export default ChangeBookingTypeModal;